import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {KTSVG} from '../../../../../_gori/helpers'

type SmartA1BatchProcessingProps = {
  progress: number
}
export const SmartA1BatchProcessing = ({progress}: SmartA1BatchProcessingProps) => {
  const intl = useIntl()

  return (
    <div>
      <div className={'border border-primary rounded p-6 mt-8 mb-6'}>
        <div>
          <h3 className='fw-bolder fs-2 d-flex align-items-center mb-3'>
            {intl.formatMessage({id: 'SMART_A1_BATCH'})}
            <KTSVG
              path='/media/gori/a1/verify.svg'
              className={clsx('svg-icon svg-icon-1 ms-2 text-primary')}
            />
          </h3>
          <span className={clsx('text-gori fw-bolder fs-6')}>
            {intl.formatMessage({id: 'GIVE_A_SUGGESTION_USING_GORI_AI_OPTIMIZATION'})}
          </span>
        </div>
        <div className='progress h-4px mt-5'>
          <div
            role='progressbar'
            className={clsx('bg-image-gori', {
              'progress-bar-animated': progress < 100,
            })}
            style={{
              width: `${progress}%`,
              transition: 'width 0.3s ease-out',
            }}
            aria-valuenow={progress}
            aria-valuemin={0}
            aria-valuemax={100}
          />
        </div>
      </div>
    </div>
  )
}
